/** Shared deadline badge helpers for issues, boards, and reports. */

export interface DeadlineDisplayFields {
  deadlineBadge?: string;
  remainingLabel?: string;
  delayLabel?: string;
  isOverdue?: boolean;
  completedOnTime?: boolean | null;
  dueDate?: string;
}

export function deadlineBadgeClass(
  badge?: string,
  isOverdue?: boolean,
  completedOnTime?: boolean | null
): string {
  if (isOverdue) return 'badge-overdue';
  if (completedOnTime === true) return 'badge-ontime';
  if (completedOnTime === false) return 'badge-late';
  const key = (badge || '').toLowerCase();
  if (key.includes('overdue')) return 'badge-overdue';
  if (key.includes('today')) return 'badge-today';
  if (key.includes('tomorrow')) return 'badge-tomorrow';
  if (key.includes('this week') || key.includes('week')) return 'badge-week';
  if (key.includes('blocked')) return 'badge-blocked';
  if (key.includes('completed') && key.includes('late')) return 'badge-late';
  if (key.includes('completed') || key.includes('on time')) return 'badge-ontime';
  return 'badge-neutral';
}

export function deadlineDisplayLabel(fields: DeadlineDisplayFields): string {
  if (fields.deadlineBadge) return fields.deadlineBadge;
  if (fields.isOverdue && fields.delayLabel) return fields.delayLabel;
  if (fields.remainingLabel && fields.remainingLabel !== '—') return fields.remainingLabel;
  if (fields.completedOnTime === true) return 'Completed On Time';
  if (fields.completedOnTime === false) return 'Completed Late';
  return fields.remainingLabel || '—';
}

export function escalationLabel(level?: number | string | null): string {
  if (level == null || level === '') return '';
  const n = typeof level === 'string' ? parseInt(level, 10) : level;
  if (!n || Number.isNaN(n)) return '';
  if (n >= 3) return 'Critical escalation';
  if (n >= 2) return 'High escalation';
  return 'Escalated';
}

export function escalationClass(level?: number | string | null): string {
  if (level == null || level === '') return '';
  const n = typeof level === 'string' ? parseInt(level, 10) : level;
  if (!n || Number.isNaN(n)) return '';
  if (n >= 3) return 'escalation-critical';
  if (n >= 2) return 'escalation-high';
  return 'escalation-low';
}
